var map = {
	"./prize-1-bm.webp": 2601,
	"./prize-1-cn.webp": 2602,
	"./prize-1.webp": 2603,
	"./prize-2-bm.webp": 2604,
	"./prize-2-cn.webp": 2605,
	"./prize-2.webp": 2606,
	"./prize-3-bm.webp": 2607,
	"./prize-3-cn.webp": 2608,
	"./prize-3.webp": 2609,
	"./prize-4-bm.webp": 2610,
	"./prize-4-cn.webp": 2611,
	"./prize-4.webp": 2612,
	"./star.svg": 2613
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 997;